import * as React from 'react';
import { SVGProps } from 'react';

const SvgChatVisit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M9.1 20.9V3.7c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v16"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M12.7 32.3c.9 2 3 3.4 5.3 3.4h5.1l2.6 2.6 6.1-6.5-2.7-2.7v-5.6c0-1.1-.7-2.2-1.7-2.7l-5.8-2.9c-.3-.1-.6-.1-.9 0L18.6 19c-1 .4-1.6 1.5-1.2 2.6.4 1 1.5 1.6 2.6 1.2l1.6-.8 1.5 1.5s-.2.2-.4.5c-1.7 2-1.4 4.9.4 6.7l.3.3m-1-1.3h-6.9"
    />
    <path fill={props.fill} d="m26.8 39.6 7.1-7-2.9-2.8-9.8 9.8h5.6Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m14.2 31.8-1.9.7c-1 .4-2.2-.2-2.6-1.2-.4-1 .2-2.2 1.2-2.6l1.9-.7c1-.4 2.2.2 2.6 1.2.3 1.1-.2 2.2-1.2 2.6ZM9.1 21.1h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1v4Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m11 28.7-1.5.4c-1.1.3-2.2-.3-2.4-1.4-.3-1.1.3-2.2 1.4-2.4l1.5-.4c1.1-.3 2.2.3 2.4 1.4.3 1-.3 2.1-1.4 2.4Z"
    />
    <path
      fill="currentColor"
      d="M20.6 6.7h-7c-.6 0-1 .4-1 1v5.2c0 .6.4 1 1 1h7c.6 0 1-.4 1-1V7.7c0-.6-.4-1-1-1Zm-3.4 5.9s-2.9-1.4-2.9-3c0-.9.7-1.6 1.5-1.6.6 0 1.1.3 1.4.8.3-.5.8-.8 1.3-.8.9 0 1.6.7 1.6 1.5 0 1.7-2.9 3.1-2.9 3.1Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M9.2 24.9h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2s-.9 2-2 2Z"
    />
    <path fill="currentColor" stroke="currentColor" d="M12.6 1.5h9v2h-9v-2Z" />
    <path fill="currentColor" d="m21.6 11.3 1.3 1.3h-1.4l-.1-.6.2-.7Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M28.9 10.3h3m-4-4 2.6-1.5m-2.6 9.5 2.6 1.5"
    />
  </svg>
);

export default SvgChatVisit;
